import { render, staticRenderFns } from "./CallOverview.vue?vue&type=template&id=51e820d1&"
import script from "./CallOverview.vue?vue&type=script&lang=js&"
export * from "./CallOverview.vue?vue&type=script&lang=js&"
import style0 from "./CallOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports